import React from "react";
import { galleryVideo } from "../assets";
import Button from "./common/Button";

const Gallery = () => {
  return (
    <>
      <div className="hidden sm:flex flex-col py-10 px-8 justify-between items-center md:px-20 md:py-16 md:flex-row">
        <div
          data-aos="fade-right"
          data-aos-duration="1200"
          className="flex flex-col lg:-mb-20 justify-center w-[380px]"
        >
          <div className="font-gunterz">
            <div className="text-white text-sm md:text-[18px] tracking-[-1px] lg:text-[25px] font-normal">
              LIGHT IS THE PAINTBRUSH
            </div>
            <div className="custom-gradient-3 tracking-[-1px] pt-1 text-[25px] lg:text-[32px] md:text-[23px] font-extrabold">
              THE WORLD IS YOUR CANVAS..
            </div>
          </div>
          <div>
            <div className="mb-5 text-white font-poppins">
              LightXR is an innovative technology that revolutionizes the
              creative process by transforming light into a virtual paintbrush.
              Harnessing the power of augmented reality (AR)
            </div>
            <Button style="font-poppins" name="View Gallery" />
          </div>
          <div className="w-full my-10 h-px border border-white"></div>
          <div className="h-36 font-poppins text-white lg:leading-5">
            Come, take a virtual tour with us to learn more about how the world
            can be your canvas!
          </div>
        </div>
        <div className="flex justify-center parent md:w-[400px]">
          <video
            autoPlay
            loop
            muted
            className="absolute object-cover z-10 w-[450px] h-[450px] lg:w-[400px] lg:h-[400px] rounded-[31px]"
          >
            <source src={galleryVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="relative child object-cover transition-all duration-300 lg:w-[400px] lg:h-[400px] w-[350px] h-[350px] left-10 top-10 bg-gradient-to-bl from-sky-500 to-green-500 rounded-[31px]" />
        </div>
      </div>

      {/* for Phone */}

      <div
        data-aos="fade-right"
        data-aos-duration="1200"
        className="flex sm:hidden flex-col py-10 px-8 justify-center items-center"
      >
        <div className="flex flex-col font-gunterz justify-center">
          <div className="text-white tracking-tighter text-xl md:text-2xl lg:text-4xl font-normal">
            LIGHT IS THE PAINTBRUSH
          </div>
          <div className="custom-gradient-2 text-2xl lg:text-5xl md:text-3xl font-extrabold">
            THE WORLD IS YOUR CANVAS..
          </div>
        </div>
        <div className="flex justify-center my-10 sm:my-0 parent md:w-[600px]">
          <video
            autoPlay
            loop
            muted
            className="absolute object-cover z-10 min-w-[330px] h-[350px] rounded-[20px] sm:rounded-[52px]"
          >
            <source src={galleryVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="relative child object-cover transition-all duration-300 md:h-[450px] md:w-[450px] lg:w-[600px] lg:h-[600px] min-w-[330px] min-h-[350px] left-2 top-2 sm:left-10 sm:top-10 bg-gradient-to-bl from-sky-500 to-green-500 rounded-[20px] sm:rounded-[52px]" />
        </div>
        <div>
          <div className="h-36 text-white font-poppins text-sm md:text-[16px] lg:text-xl font-normal lg:leading-9">
            LightXR is an innovative technology that revolutionizes the creative
            process by transforming light into a virtual paintbrush. Harnessing
            the power of augmented reality (AR)
          </div>
          <Button name="View Gallery" />
        </div>
        <div className="w-80 mt-10 mb-5 h-px border border-white"></div>
        <div className="h-36 md:w-96 font-poppins text-white text-sm md:text-[16px] lg:text-xl lg:leading-7">
          LightXR is an innovative technology that revolutionizes the creative
          process by
        </div>
      </div>
    </>
  );
};

export default Gallery;
